import { render } from "./ContentVue.vue?vue&type=template&id=6d604533"
import script from "./ContentVue.vue?vue&type=script&lang=js"
export * from "./ContentVue.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hammer\\andolphi-curriculo-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__